<template>
  <v-data-table :items="this.groups" hide-actions class="elevation-0" ref="groups">
    <template #no-data>
      <span></span>
    </template>

    <!-- HEADERS -->
    <template #headers>
      <th v-for="(header, index) in headers" ref="headers" :key="`header-${index}`"
        :style="{ width: header.width, textAlign: header.align }" :data-custom-property="header.custom_property">
        <strong>{{ header.text }}</strong>
      </th>
    </template>

    <!-- GROUPS -->
    <template #items="group">
      <!-- {{groups.length}} -->
      <Group v-show="filter(group.item, filter_text)" :key="`group-${group.item.name}`" :group="group.item"
        :filter_text="filter_text" :grouped_by="grouped_by" :headers_length="headers.length"
        :disable_select_action="disable_select_action" />
    </template>
  </v-data-table>
</template>

<script>
import { mapState } from 'vuex';
import { filter } from "@/utils/functions";

export default {
  props: {
    headers: {
      type: Array,
      required: true
    },
    groups: {
      type: Array,
      required: true
    },
    filter_text: {
      type: String,
      required: true
    },
    grouped_by: {
      type: String,
      required: true
    },
    disable_select_action: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      table_size_observer: null,
      table_width_current: 0
    }
  },
  components: {
    Group: () => import("./Group.desktop"),
  },
  computed: {
    ...mapState({
      skin: state => state.settings.skin
    }),
  },
  methods: {
    filter,
  },
  mounted() {
    let root = document.querySelector(':root').style;
    let part_info_width = 0;

    this.$refs.headers.forEach((header, index) => {
      let header_width = header.scrollWidth;
      root.setProperty(header.dataset.customProperty, `${header_width}px`);

      if (index > 1)
        part_info_width += header_width;
    });

    root.setProperty('--part-info-width', `${part_info_width}px`);
  },
  beforeUnmount() {
    this.headers_size_observers.forEach(header_observer => header_observer.unobserve());
  }
}
</script>